import { action, computed, observable } from 'mobx';
import Abstract from './abstract';
import deepEqual from 'deep-equal';

export class Catalog extends Abstract {
  @observable public courseSeries = [];
  @observable public current = null;
  @observable public publishState = null;
  @observable public kellyCourse = null;
  @observable public resources = [];
  @observable public toolbar = { uuids: [], uuid: null };

  @computed get courseSeriesSchema() {
    return nx.get(this.current, 'courseSeriesSchema');
  }

  @computed get publishCanAction() {
    const canCancel = nx.get(this.publishState, 'canCancel', false);
    return canCancel || alo7Account.uuid === nx.get(this.publishState, 'creatorUuid');
  }

  @computed get resourceIds() {
    return this.resources.map(item => item.uuid);
  }

  @computed get toolbarChecked() {
    const ids = this.resourceIds;
    if (!this.resources.length) return false;
    return deepEqual(ids.sort(), this.toolbar.uuids.sort());
  }

  @action
  public init = () => {
    const { course } = this.root.params;
    return nx.$api
      .course_catalogues({
        subject: alo7Nav.subject,
        courseUuid: course,
      })
      .then(res => (this.current = res));
  };
}
